
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Collapse, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import AmountFormat from "../../components/AmountFormat.js";
import InputNumberFormat from "../../components/InputNumberFormat.js";
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const MyWallet = () => {

    const [data, setData] = useState([]);
    const [WalletModel, setWalletModel] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [loadingWithdraw, setLoadingWithdraw] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [id, setId] = useState(0);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, data: {} });
    const [accountBalance, setAccountBalance] = useState('');
    const [isShowCreateWalletModalVisible, setIsShowCreateWalletModalVisible] = useState(false);
    const [isShowWithdrawModalVisible, setIsShowWithdrawModalVisible] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);
    const [reload, setReload] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchData()
    }, [reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
                setReload(true);
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {
        if (!loadingMore) setLoading(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/wallet/GetMyTransactions`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            result.items.map(item => {
                item.key = item.id
            })
            setCount(result.count)
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            if (filter.skip === 0) fetchAccountBalance();
            setReload(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setReload(false)
            setLoading(false);
        } finally {
            setReload(false)
            setLoadingMore(false)
            //setLoading(false);
        }
    };

    const refreshWallet = () => {
        setData([]);
        setFilter((current) => ({ ...current, skip: 0 }));
        setLoading(true);
        setLoadingMore(false);
        setReload(true);
    };

    const fetchAccountBalance = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/GetAccountBalance`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            setAccountBalance(result)
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
        } finally {
            setLoading(false);
        }
    };

    const createWallet = async () => {
        setLoadingSave(true);
        const token = localStorage.getItem('damavandclub-token')
        try {

            var response = await axios.get(`${baseURL}/payment/IncreaseAccountBalance?amount=${WalletModel.amount}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            // toast.success('در حال انتقال به درگاه...', {
            //     position: 'bottom-right',
            //     autoClose: 1000, // milliseconds
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     //className: 'custom-toast',
            //     pauseOnHover: true,
            //     draggable: true,
            // });
            var result = response.data.data;

            const newWindow = window.open('', '_blank');

            if (newWindow) {
                newWindow.location.href = result;
            } else {
                // در صورتی که پیش باز کردن پنجره مسدود شده باشد
                window.location.href = result;
            }

            refreshWallet()
            setLoadingSave(false);
            setIsShowCreateWalletModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const withdrawRequest = async () => {
        const requestedAmount = Number(String(withdrawAmount || '').replace(/,/g, ''));
        const currentBalance = Number(String(accountBalance || '').replace(/,/g, ''));
        if (!requestedAmount || requestedAmount > currentBalance) {
            toast.error(requestedAmount > currentBalance ? 'مبلغ درخواستی نمی‌تواند بیشتر از موجودی کیف پول باشد.' : 'لطفاً مبلغ درخواستی را وارد کنید.');
            return;
        }
        setLoadingWithdraw(true);
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/wallet/withdrawrequest`, { amount: withdrawAmount }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            toast.success(result, {
                position: 'bottom-right',
                autoClose: 7000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });

            setLoadingWithdraw(false);
            setIsShowWithdrawModalVisible(false);
            refreshWallet();

        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 4000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingWithdraw(false);
            setIsShowWithdrawModalVisible(false);
        } finally {
            setLoadingWithdraw(false);
            setIsShowWithdrawModalVisible(false);
            //setLoading(false);
        }
    };

    const showCreateWalletModal = async () => {
        setWalletModel({})
        setIsShowCreateWalletModalVisible(true)
    };

    return (
        <div className="my-wallet-page">
            <HideSidebarInMobileMode />
            {!loading ? <Button className="members-wallet-action members-wallet-create my-wallet-balance-button" onClick={() => showCreateWalletModal()} style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, width: '100%', marginBottom: 10 }}
                type="primary"><label>افزایش موجودی کیف پول</label><span>موجودی: <AmountFormat amount={accountBalance} /> ریال</span></Button> : null}

            {!loading ? <Button className="members-wallet-action my-wallet-withdraw-button" onClick={() => setIsShowWithdrawModalVisible(true)} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                type="primary"><label>برداشت از کیف پول</label></Button> : null}
            {loading && !loadingMore ? <div className="my-wallet-transactions-loading"><Spin size="large" /></div> : data.length > 0 ?
                <div className="my-wallet-transaction-grid">
                    {data.map((record, index) => (
                        <article className={`my-wallet-transaction-card ${record.increaseMode ? 'is-credit' : 'is-debit'}`} key={record.key || record.id || index}>
                            <div className="my-wallet-transaction-card-top">
                                <span className="my-wallet-transaction-direction">{record.increaseMode ? '↑ واریز' : '↓ برداشت'}</span>
                                <span className="my-wallet-transaction-index">#{index + 1}</span>
                            </div>
                            <div className="my-wallet-transaction-amount-row">
                                <div className="my-wallet-transaction-amount-label">مبلغ تراکنش</div>
                                <div className="my-wallet-transaction-amount"><AmountFormat amount={record.amount} /><span>ریال</span></div>
                            </div>
                            <div className="my-wallet-transaction-details">
                                {record.walletTypeTitle ? <div><span>نوع تراکنش</span><strong>{record.walletTypeTitle}</strong></div> : null}
                                {record.description ? <div><span>توضیحات</span><strong>{record.description}</strong></div> : null}
                                {record.creatorName ? <div><span>ثبت‌کننده</span><strong>{record.creatorName}</strong></div> : null}
                                {record.persianCreateDate ? <div><span>تاریخ ثبت</span><strong>{record.persianCreateDate}</strong></div> : null}
                            </div>
                        </article>
                    ))}
                </div> : !loading ? <div className="my-wallet-transactions-empty">تراکنشی برای نمایش وجود ندارد</div> : null}
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-wallet-total">
                <span>تعداد کل تراکنش‌ها</span>
                <strong>{count}</strong>
            </div>
            <Modal
                className="wallet-topup-modal"
                title={`افزایش موجودی کیف پول`}
                open={isShowCreateWalletModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container wallet-topup-footer'>
                    <Button onClick={() => {
                        setWalletModel({})
                        setIsShowCreateWalletModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loadingSave}
                        onClick={() => createWallet()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>اتصال به درگاه بانک</Button>
                </div>}
            >
                <div className="wallet-topup-content">
                    <div className="wallet-topup-balance">
                        <span className="wallet-topup-balance-icon">+</span>
                        <div><span>موجودی فعلی</span><strong><AmountFormat amount={accountBalance} /> <small>ریال</small></strong></div>
                    </div>
                    <label className="wallet-topup-amount-label">مبلغ مورد نظر برای شارژ</label>
                    <div className="wallet-topup-amount-input">
                        <InputNumberFormat value={WalletModel.amount} placeholder="مبلغ را به ریال و با اعداد انگلیسی وارد کنید"
                            onValueChange={(value) => setWalletModel({ ...WalletModel, amount: value })} />
                        <span>ریال</span>
                    </div>
                    <div className="wallet-topup-notice">
                        <strong>راهنمای پرداخت</strong>
                        <p>شارژ کیف پول برای پرداخت هزینه برنامه‌ها و کلاس‌های باشگاه است. در صورت انصراف، مبلغ با کسر تعرفه انصراف به کیف پول بازمی‌گردد.</p>
                    </div>
                    <div className="wallet-topup-hint">هنگام اتصال به درگاه بانک فیلترشکن را خاموش کنید و تا بازگشت به این صفحه صبر کنید.</div>
                </div>
            </Modal>

            <Modal
                className="wallet-topup-modal wallet-withdraw-modal"
                title={`برداشت از کیف پول`}
                open={isShowWithdrawModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container wallet-topup-footer'>
                    <Button onClick={() => {
                        setWalletModel({})
                        setIsShowWithdrawModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button className="wallet-withdraw-submit" type="primary" loading={loadingWithdraw}
                        disabled={!withdrawAmount || Number(String(withdrawAmount).replace(/,/g, '')) > Number(String(accountBalance || '').replace(/,/g, ''))}
                        onClick={() => withdrawRequest()}
                        style={{ width: '100%', marginRight: 10 }}>ثبت درخواست برداشت</Button>
                </div>}
            >
                <div className="wallet-withdraw-content">
                    <div className="wallet-topup-balance">
                        <span className="wallet-topup-balance-icon">◉</span>
                        <div><span>موجودی فعلی کیف پول</span><strong><AmountFormat amount={accountBalance} /> <small>ریال</small></strong></div>
                    </div>
                    <label className="wallet-topup-amount-label">مبلغ درخواستی</label>
                    <div className="wallet-topup-amount-input">
                        <InputNumberFormat value={withdrawAmount} placeholder="مبلغ را به ریال و با اعداد انگلیسی وارد کنید"
                            onValueChange={(value) => setWithdrawAmount(value)} />
                        <span>ریال</span>
                    </div>
                    {Number(String(withdrawAmount || '').replace(/,/g, '')) > Number(String(accountBalance || '').replace(/,/g, '')) ?
                        <div className="wallet-withdraw-error">مبلغ درخواستی نمی‌تواند بیشتر از موجودی کیف پول باشد.</div> : null}
                    <div className="wallet-withdraw-note">
                        درخواست برداشت شما به اطلاع بخش مالی خواهد رسید و مبلغ طی ساعات آینده واریز خواهد شد.
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default MyWallet
